import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Loading from "../../component/Loading/Loading";
import AlertMsg from "../../component/AlertMsg/AlertMsg";
import useAxiosInstance from "../../services/useAxiosInstance";

const ContractGeneration = () => {
  const history = useHistory();
  const axiosInstance = useAxiosInstance();
  const communityId = useSelector((state) => state.auth.communityId);
  const userId = useSelector((state) => state.auth.userId);
  const employeeId = useSelector((state) => state.auth.employeeId);
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleKeyPress = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const [planData, setPlanData] = useState({});
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString();
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [formData, setFormData] = useState({
    addressDto: {
      activeStatus: true,
      address: "",
      addressId: 0,
      city: "",
      countryId: 0,
      stateId: 0,
      zipCode: 0,
    },
    clientRequest: {
      boardMemberRole: "",
      addressDto: {
        activeStatus: true,
        address: "",
        addressId: 0,
        city: "",
        countryId: 0,
        stateId: 0,
        zipCode: 0,
      },
      clientDto: {
        activeStatus: true,
        clientid: 0,
        communityid: null,
        displayname: " ",
        numberofhouses: 0,
        userid: 0,
      },
      contractCode: " ",
      userDto: {
        activeStatus: false,
        emailId: "",
        userId: 0,
        emailIdIsVerified: true,
        firstName: "",
        isClient: false,
        lastLogin: formattedDate,
        lastName: "",
        middleName: "",
        mobileIsVerified: true,
        mobileNumber: "",
        otp: 0,
        password: "",
        roleId: 1002,
        createdDate: formattedDate,
        modifiedbyId: null,
        modifiedDate: formattedDate,
      },
    },
    contractDto: {
      annualrenewalfee: planData.price,
      buisnessname: "",
      businessaddressid: null,
      clientid: 0,
      communicationchannel: "",
      contractcode: "",
      contractid: 0,
      createdbyid: userId,
      createddate: formattedDate,
      istermsaccepted: true,
      modifiedbyid: null,
      modifieddate: formattedDate,
      onetimesetup: 0,
      planid: 0,
      renewalcycles: planData.planPeriod,
      salespersonid: employeeId,
      sizeofthecommunity: "planData.planRange",
    },
  });

  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedCommunityCountryId, setSelectedCommunityCountryId] = useState("");

  const [planFormData, setPlanFormData] = useState({
    planPeriod: "",
    planRange: "",
    planType: "",
  });
  const [planPeriods, setPlanPeriods] = useState([]);
  const [planRangeData, setPlanRangeData] = useState([]);
  const [planTypeData, setPlanTypeData] = useState([]);

  const displayValue = (value) => {
    return value === 0 ? "" : value;
  };

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`/api/public/country/getAll`)
      .then((response) => setCountryData(response.data))
      .catch((error) => console.error("Error fetching countries:", error));
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`/api/public/state/getAll`)
      .then((response) => setStateData(response.data))
      .catch((error) => console.error("Error fetching states:", error));
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);

    async function fetchPlanPeriods() {
      try {
        const response = await axiosInstance.get(`/api/public/plan-period/all`);
        setPlanPeriods(response.data);
      } catch (error) {
        console.error("Error fetching plan period data:", error);
      } finally {
        setLoading(false);
      }
    }

    async function fetchPlanRanges() {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`/api/public/plan-range/all`);
        setPlanRangeData(response.data);
      } catch (error) {
        console.error("Error fetching plan range data:", error);
      } finally {
        setLoading(false);
      }
    }

    async function fetchPlanTypes() {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`/api/public/plan-type/all`);
        setPlanTypeData(response.data);
      } catch (error) {
        console.error("Error fetching plan type data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchPlanPeriods();
    fetchPlanRanges();
    fetchPlanTypes();
  }, []);

  useEffect(() => {
    if (
      planFormData.planPeriod &&
      planFormData.planRange &&
      planFormData.planType
    ) {
      handleFind();
    }
  }, [planFormData]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractDto: {
        ...prevFormData.contractDto,
        annualrenewalfee: planData.price,
        planid: planData.planId,
      },
    }));
  }, [planData.price, planData.planId, planData.planRange]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractDto: {
        ...prevFormData.contractDto,
        renewalcycles: planData.planPeriod
          ? planData.planPeriod.planPeriod
          : "",
        sizeofthecommunity: planData.planRange
          ? parseCommunitySize(planData.planRange.planRange)
          : "",
      },
    }));
  }, [planData.planPeriod, planData.planRange]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [section, ...nestedProperties] = name.split(".");

    setFormErrors((prevErrors) => {
      const formErrors = { ...prevErrors };

      if (value) {
        delete formErrors[name];
      } else {
        formErrors[name] = "This field is required";
      }

      return formErrors;
    });

    let sanitizedValue = value;
    if (name === "clientRequest.userDto.mobileNumber") {
      sanitizedValue = value.replace(/[^0-9]/g, "");
    }

    if (name === "addressDto.countryId") {
      setSelectedCommunityCountryId(sanitizedValue);
    }
    if (name === "clientRequest.addressDto.countryId") {
      setSelectedCountryId(sanitizedValue);
    }

    const updateNestedProperty = (obj, props, val) => {
      if (props.length === 0) {
        if (
          [
            "addressDto.countryId",
            "addressDto.stateId",
            "clientRequest.addressDto.countryId",
            "clientRequest.addressDto.stateId",
          ].includes(name)
        ) {
          return parseInt(val, 10);
        }
        return val;
      }
      const [currentProp, ...remainingProps] = props;
      return {
        ...obj,
        [currentProp]: updateNestedProperty(
          obj[currentProp],
          remainingProps,
          val
        ),
      };
    };

    setFormData((prevState) => {
      if (section === "addressDto" || section === "contractDto") {
        return {
          ...prevState,
          [section]: updateNestedProperty(
            prevState[section],
            nestedProperties,
            sanitizedValue
          ),
        };
      } else if (section === "clientRequest") {
        return {
          ...prevState,
          clientRequest: {
            ...prevState.clientRequest,
            [nestedProperties[0]]: updateNestedProperty(
              prevState.clientRequest[nestedProperties[0]],
              nestedProperties.slice(1),
              sanitizedValue
            ),
          },
        };
      } else {
        throw new Error(`Unsupported section: ${section}`);
      }
    });
  };

  const handlePhoneNumberChange = (value, country) => {
    const isValid = value && value.length === 11;

    setFormData((prevFormData) => ({
      ...prevFormData,
      clientRequest: {
        ...prevFormData.clientRequest,
        userDto: {
          ...prevFormData.clientRequest.userDto,
          mobileNumber: value || '',
        },
      },
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      mobileNumber: isValid ? '' : 'Phone number must be exactly 10 digits',
    }));
  };

  const handlePlanChange = (e) => {
    const { name, value } = e.target;
    setPlanFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFind = async () => {
    const { planPeriod, planRange, planType } = planFormData;

    if (planPeriod && planRange && planType) {
      const url = `/api/public/plan/find/${planType}/${planRange}/${planPeriod}`;
      try {
        const response = await axiosInstance.get(url);
        setPlanData(response.data);
      } catch (error) {
        console.error("Error fetching plan data:", error);
      }
    } else {
      console.error("One or more of the plan data parameters are undefined.");
    }
  };

  const parseCommunitySize = (rangeString) => {
    const parts = rangeString.split("-");
    const sizeOfCommunity = parseInt(parts[1]);
    return sizeOfCommunity;
  };

  const handleEmailCheck = async (emailId) => {
    try {
      const response = await axiosInstance.get(`/api/user/check/email?emailId=${emailId} `);
      if (response.status === 200) {
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error checking email:', error);
      return true;
    }
  };

  const validateForm = async () => {
    const formErrors = {};

    if (!formData.clientRequest.userDto.firstName) {
      formErrors.firstName = "First Name is required";
    } else if (formData.clientRequest.userDto.firstName.length > 20) {
      formErrors.firstName = "First Name must be less than 20 characters";
    }

    if (!formData.clientRequest.userDto.lastName) {
      formErrors.lastName = "Last Name is required";
    } else if (formData.clientRequest.userDto.lastName.length > 20) {
      formErrors.lastName = "Last Name must be less than 20 characters";
    }

    if (!formData.clientRequest.userDto.emailId || !formData.clientRequest.userDto.emailId.trim()) {
      formErrors.emailId = "Please provide your email address.";
    } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(formData.clientRequest.userDto.emailId)) {
      formErrors.emailId = "Please provide a valid email address (lowercase letters only).";
    } else if (!formData.clientRequest.userDto.emailId.endsWith('@gmail.com')) {
      formErrors.emailId = "Email must be a Gmail address";
    } else {
      const emailId = formData.clientRequest.userDto.emailId;
      const isEmailAvailable = await handleEmailCheck(emailId);
      if (!isEmailAvailable) {
        console.log('ok');
      } else {
        formErrors.emailId = 'Email is already taken';
        console.log('not ok');
      }
    }

    if (!formData.clientRequest.userDto.mobileNumber.trim()) {
      formErrors.mobileNumber = 'Phone Number is required';
    } else if (formData.clientRequest.userDto.mobileNumber.length < 10) {
      formErrors.mobileNumber = 'Phone Number must be exactly 10 digits';
    }

    if (!formData.clientRequest.addressDto.address) {
      formErrors.ClientAddress = "Address is required";
    } else if (formData.clientRequest.addressDto.address.length > 100) {
      formErrors.ClientAddress = "Address must be less than 100 characters";
    }

    if (!formData.clientRequest.addressDto.stateId) {
      formErrors.ClientStateId = "State is required";
    }

    if (!formData.clientRequest.addressDto.countryId) {
      formErrors.ClientCountryId = "Country is required";
    }

    if (!formData.clientRequest.addressDto.zipCode) {
      formErrors.ClientZipCode = "Zip Code is required";
    }

    if (!formData.clientRequest.addressDto.city) {
      formErrors.ClientCity = "City is required";
    }

    if (!formData.contractDto.buisnessname) {
      formErrors.buisnessname = "Business Name is required";
    } else if (formData.contractDto.buisnessname.length > 20) {
      formErrors.buisnessname = "Business Name must be less than 20 characters";
    }

    if (!formData.addressDto.address) {
      formErrors.address = "Address is required";
    } else if (formData.addressDto.address.length > 100) {
      formErrors.address = "Address must be less than 100 characters";
    }

    if (!formData.addressDto.stateId) {
      formErrors.stateId = "State is required";
    }

    if (!formData.addressDto.countryId) {
      formErrors.countryId = "Country is required";
    }

    if (!formData.addressDto.zipCode) {
      formErrors.zipCode = "Zip Code is required";
    }

    if (!formData.addressDto.city) {
      formErrors.city = "City is required";
    }

    if (!formData.contractDto.communicationchannel) {
      formErrors.communicationchannel = "Communication channel is required";
    } else if (formData.contractDto.communicationchannel.length > 20) {
      formErrors.communicationchannel = "Communication channel must be less than 20 characters";
    }

    if (!planFormData.planRange) {
      formErrors.planRange = "Plan Range is required";
    } else if (planFormData.planRange.length > 20) {
      formErrors.planRange = "Plan Range must be less than 20 characters";
    }

    if (!planFormData.planType) {
      formErrors.planType = "Plan Type is required";
    } else if (planFormData.planType.length > 20) {
      formErrors.planType = "Plan Type must be less than 20 characters";
    }

    if (!planFormData.planPeriod) {
      formErrors.planPeriod = "Plan Period is required";
    } else if (planFormData.planPeriod.length > 20) {
      formErrors.planPeriod = "Plan Period must be less than 20 characters";
    }

    if (!formData.contractDto.onetimesetup) {
      formErrors.onetimesetup = "One Time Setup is required";
    } else if (formData.contractDto.onetimesetup.length > 6) {
      formErrors.onetimesetup = "One Time Setup must be less than 6 characters";
    }

    return formErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const errors = await validateForm();
    if (Object.keys(errors).length === 0) {
      try {
        const responseData = await axiosInstance.post(
          '/api/public/contract/add',
          formData
        );

        if (responseData.data && responseData.data.contractcode) {
          const contractCodeString = responseData.data.contractcode.toString();
          const emailInvitationData = {
            clientEmail: formData.clientRequest.userDto.emailId,
            clientName: formData.clientRequest.userDto.firstName,
            contractCode: contractCodeString,
          };

          await axiosInstance.post(
            '/api/public/emailInvitation/send-invitation-To-The-First-Client',
            emailInvitationData
          );

          setAlert({ visible: true, message: 'Contract added successfully!', type: 'success' });
          setTimeout(() => {
            history.goBack();
          }, 2500);
        } else {
          console.error('Error: Contract code not found in the response');
          setAlert({ visible: true, message: 'Error adding Contract. Please try again.', type: 'error' });
        }
      } catch (error) {
        console.error('Error:', error);
        setAlert({ visible: true, message: 'Error adding Contract. Please try again.', type: 'error' });
      } finally {
        setLoading(false);
      }
    } else {
      setFormErrors(errors);
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    history.goBack();
  };

  const handleCancel = () => {
    setFormErrors({});
    setFormData({
      addressDto: {
        activeStatus: true,
        address: "",
        addressId: 0,
        city: "",
        countryId: 0,
        stateId: 0,
        zipCode: 0,
      },
      clientRequest: {
        boardMemberRole: " ",
        addressDto: {
          activeStatus: true,
          address: "",
          addressId: 0,
          city: "",
          countryId: 0,
          stateId: 0,
          zipCode: 0,
        },
        clientDto: {
          activeStatus: true,
          clientid: 0,
          communityid: null,
          displayname: " ",
          numberofhouses: 0,
          userid: 0,
        },
        contractCode: " ",
        userDto: {
          activeStatus: false,
          emailId: "",
          userId: 0,
          emailIdIsVerified: true,
          firstName: "",
          isClient: false,
          lastLogin: formattedDate,
          lastName: "",
          middleName: "",
          mobileIsVerified: true,
          mobileNumber: "",
          otp: 0,
          password: "",
          roleId: 1002,
        },
      },
      contractDto: {
        annualrenewalfee: planData.price,
        buisnessname: "",
        businessaddressid: null,
        clientid: 0,
        communicationchannel: "",
        contractcode: "",
        contractid: 0,
        createdbyid: userId,
        createddate: formattedDate,
        istermsaccepted: true,
        modifiedbyid: null,
        modifieddate: formattedDate,
        onetimesetup: 0,
        planid: 0,
        renewalcycles: planData.planPeriod,
        salespersonid: employeeId,
        sizeofthecommunity: "planData.planRange",
      },
    });

    setPlanFormData({
      planPeriod: "",
      planRange: "",
      planType: "",
    });

    handleBackClick();
  };

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}

          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Contract Generation</h1>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Client Details Section */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <div className="border-b px-6 py-4">
                <h2 className="text-xl font-semibold text-gray-800">Client Details</h2>
              </div>

              <div className="p-6 space-y-6">
                {/* First row - Name fields */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.firstName"
                      id="firstName"
                      value={formData.clientRequest.userDto.firstName}
                      onChange={handleChange}
                      maxLength="20"
                      className={`w-full rounded-md border ${formErrors.firstName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.firstName && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.firstName}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Middle Name
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.middleName"
                      id="middleName"
                      value={formData.clientRequest.userDto.middleName}
                      onChange={handleChange}
                      maxLength="20"
                      className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.lastName"
                      value={formData.clientRequest.userDto.lastName}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.lastName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.lastName && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.lastName}</p>
                    )}
                  </div>
                </div>

                {/* Second row - Contact Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mobile Number <span className="text-red-500">*</span>
                    </label>
                    <PhoneInput
                      placeholder="Enter phone number"
                      value={formData.clientRequest.userDto.mobileNumber}
                      onChange={handlePhoneNumberChange}
                      country={"us"}
                      defaultCountry="US"
                      containerClass="phone-input-container"
                      inputClass={`w-full rounded-md border px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${formErrors.mobileNumber ? 'border-red-500' : 'border-gray-300'}`}
                      buttonStyle={{ border: "none", background: "transparent" }}
                    />
                    {formErrors.mobileNumber && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.mobileNumber}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.emailId"
                      value={formData.clientRequest.userDto.emailId}
                      onChange={handleChange}
                      maxLength="50"
                      className={`w-full rounded-md border ${formErrors.emailId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.emailId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.emailId}</p>
                    )}
                  </div>
                </div>

                {/* Client Address */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="address"
                    id="address"
                    name="clientRequest.addressDto.address"
                    value={formData.clientRequest.addressDto.address}
                    onChange={handleChange}
                    maxLength="100"
                    className={`w-full rounded-md border ${formErrors.ClientAddress ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {formErrors.ClientAddress && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.ClientAddress}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="clientRequest.addressDto.city"
                    value={formData.clientRequest.addressDto.city}
                    onChange={handleChange}
                    maxLength="50"
                    className={`w-full rounded-md border ${formErrors.ClientCity ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {formErrors.ClientCity && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.ClientCity}</p>
                  )}
                </div>

                {/* Location fields */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Country <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="countryId"
                      name="clientRequest.addressDto.countryId"
                      value={formData.clientRequest.addressDto.countryId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.ClientCountryId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Country</option>
                      {countryData.map((country) => (
                        <option key={country.countryid} value={country.countryid}>
                          {country.countryname}
                        </option>
                      ))}
                    </select>
                    {formErrors.ClientCountryId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.ClientCountryId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      State <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="stateId"
                      name="clientRequest.addressDto.stateId"
                      value={formData.clientRequest.addressDto.stateId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.ClientStateId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select State</option>
                      {stateData
                        .filter(
                          (state) =>
                            state.countryid === parseInt(selectedCountryId)
                        )
                        .map((state) => (
                          <option key={state.stateid} value={state.stateid}>
                            {state.statename}
                          </option>
                        ))}
                    </select>
                    {formErrors.ClientStateId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.ClientStateId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Zip Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="ClientZipCode"
                      name="clientRequest.addressDto.zipCode"
                      value={displayValue(formData.clientRequest.addressDto.zipCode)}
                      maxLength={6}
                      onKeyPress={handleKeyPress}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.ClientZipCode ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.ClientZipCode && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.ClientZipCode}</p>
                    )}
                  </div>
                </div>

                {/* Business Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Business Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="contractDto.buisnessname"
                    value={formData.contractDto.buisnessname}
                    onChange={handleChange}
                    maxLength="20"
                    className={`w-full rounded-md border ${formErrors.buisnessname ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {formErrors.buisnessname && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.buisnessname}</p>
                  )}
                </div>

                {/* Business Address */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Business Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="address"
                      id="address"
                      name="addressDto.address"
                      value={formData.addressDto.address}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.address ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      maxLength="100"
                    />
                    {formErrors.address && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.address}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      City <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="city"
                      name="addressDto.city"
                      value={formData.addressDto.city}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.city ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.city && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.city}</p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Country <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="countryid"
                      name="addressDto.countryId"
                      value={formData.addressDto.countryId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.countryId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Country</option>
                      {countryData.map((country) => (
                        <option key={country.countryid} value={country.countryid}>
                          {country.countryname}
                        </option>
                      ))}
                    </select>
                    {formErrors.countryId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.countryId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      State <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="stateId"
                      name="addressDto.stateId"
                      value={formData.addressDto.stateId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.stateId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select State</option>
                      {stateData
                        .filter(
                          (state) =>
                            state.countryid === parseInt(selectedCommunityCountryId)
                        )
                        .map((state) => (
                          <option key={state.stateid} value={state.stateid}>
                            {state.statename}
                          </option>
                        ))}
                    </select>
                    {formErrors.stateId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.stateId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Zip Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="zipCode"
                      name="addressDto.zipCode"
                      value={displayValue(formData.addressDto.zipCode)}
                      onChange={handleChange}
                      maxLength={6}
                      onKeyPress={handleKeyPress}
                      className={`w-full rounded-md border ${formErrors.zipCode ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.zipCode && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.zipCode}</p>
                    )}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Preferred Communication Channel <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="contractDto.communicationchannel"
                    value={formData.contractDto.communicationchannel}
                    onChange={handleChange}
                    className={`w-full rounded-md border ${formErrors.communicationchannel ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <option value="">Select</option>
                    <option value="Email">Email</option>
                    <option value="Phone (sms)">Phone (sms)</option>
                    <option value="Phone (Call)">Phone (Call)</option>
                    <option value="Mail">Mail</option>
                  </select>
                  {formErrors.communicationchannel && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.communicationchannel}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Plan Details Section */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <div className="border-b px-6 py-4">
                <h2 className="text-xl font-semibold text-gray-800">Plan Details</h2>
              </div>

              <div className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Size of the Community <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="planRange"
                      value={planFormData.planRange}
                      onChange={handlePlanChange}
                      className={`w-full rounded-md border ${formErrors.planRange ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Plan Range</option>
                      {planRangeData.map((range) => (
                        <option key={range.id} value={range.id}>
                          {range.planRange}
                        </option>
                      ))}
                    </select>
                    {formErrors.planRange && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.planRange}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Plan Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="planType"
                      value={planFormData.planType}
                      onChange={handlePlanChange}
                      className={`w-full rounded-md border ${formErrors.planType ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Plan Type</option>
                      {planTypeData.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.planType}
                        </option>
                      ))}
                    </select>
                    {formErrors.planType && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.planType}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Renewal Cycles <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="planPeriod"
                      value={planFormData.planPeriod}
                      onChange={handlePlanChange}
                      className={`w-full rounded-md border ${formErrors.planPeriod ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Plan Period</option>
                      {planPeriods.map((period) => (
                        <option key={period.id} value={period.id}>
                          {period.planPeriod}
                        </option>
                      ))}
                    </select>
                    {formErrors.planPeriod && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.planPeriod}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Plan Price
                    </label>
                    <input
                      type="text"
                      id="planPrice"
                      name="planData.price"
                      value={planData.price}
                      className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      One Time Setup <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="contractDto.onetimesetup"
                      value={displayValue(formData.contractDto.onetimesetup)}
                      onChange={handleChange}
                      maxLength={6}
                      className={`w-full rounded-md border ${formErrors.onetimesetup ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.onetimesetup && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.onetimesetup}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex justify-between items-center mb-6">
              <div className="text-sm text-red-500">
                * Required fields
              </div>
              <div className="flex space-x-4">
                <button
                  type="button"
                  onClick={handleCancel}
                  className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ContractGeneration;